export default () => {
	let controller

	return {
		async fetch(request, opts = {}) {
			controller = new AbortController()

			return await fetch(request, { ...opts, signal: controller.signal })
		},

		abort() {
			controller?.abort?.()
		}
	}
}
